import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Pencil, Trash2, Eye, Search } from 'lucide-react';
import { useData } from '../../context/DataContext';

const AdminProjects = () => {
  const { projects, deleteProject } = useData();
  const [search, setSearch] = useState('');
  const [deleteId, setDeleteId] = useState(null);

  const filteredProjects = projects.filter((p) =>
    p.title.toLowerCase().includes(search.toLowerCase())
  );

  const handleDelete = (id) => {
    deleteProject(id);
    setDeleteId(null);
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
        <h1 className="text-2xl font-bold text-white">Projeler</h1>
        <Link
          to="/admin/projeler/yeni"
          className="flex items-center space-x-2 px-4 py-2 bg-gold text-anthracite font-medium rounded hover:bg-gold-light transition-colors duration-300"
        >
          <Plus className="w-5 h-5" />
          <span>Yeni Proje</span>
        </Link>
      </div>

      {/* Search */}
      <div className="mb-6">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
          <input
            type="text"
            placeholder="Proje ara..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full pl-10 pr-4 py-3 bg-anthracite-light border border-gold/20 rounded text-white focus:border-gold focus:outline-none transition-colors duration-300"
          />
        </div>
      </div>

      {/* Projects List */}
      <div className="bg-anthracite-light rounded-lg border border-gold/10 overflow-hidden">
        {filteredProjects.length === 0 ? (
          <div className="p-8 text-center text-gray-400">
            {search ? 'Arama sonucu bulunamadı.' : 'Henüz proje eklenmemiş.'}
          </div>
        ) : (
          <div className="divide-y divide-gold/10">
            {filteredProjects.map((project) => (
              <div
                key={project.id}
                className="p-4 flex flex-col sm:flex-row items-start sm:items-center gap-4"
              >
                {/* Image */}
                <img
                  src={project.coverImage}
                  alt={project.title}
                  className="w-20 h-14 object-cover rounded"
                />

                {/* Info */}
                <div className="flex-1">
                  <h3 className="text-white font-medium">{project.title}</h3>
                  <div className="flex items-center gap-4 mt-1">
                    <span
                      className={`text-xs px-2 py-0.5 rounded ${
                        project.status === 'Biten'
                          ? 'bg-green-500/20 text-green-400'
                          : 'bg-gold/20 text-gold'
                      }`}
                    >
                      {project.status}
                    </span>
                    <span className="text-gray-400 text-sm">{project.location}</span>
                  </div>
                </div>

                {/* Actions */}
                <div className="flex items-center space-x-2">
                  <Link
                    to={`/projeler/${project.id}`}
                    target="_blank"
                    className="p-2 text-gray-400 hover:text-gold transition-colors duration-300"
                    title="Önizleme"
                  >
                    <Eye className="w-5 h-5" />
                  </Link>
                  <Link
                    to={`/admin/projeler/${project.id}`}
                    className="p-2 text-gray-400 hover:text-gold transition-colors duration-300"
                    title="Düzenle"
                  >
                    <Pencil className="w-5 h-5" />
                  </Link>
                  <button
                    onClick={() => setDeleteId(project.id)}
                    className="p-2 text-gray-400 hover:text-red-400 transition-colors duration-300"
                    title="Sil"
                  >
                    <Trash2 className="w-5 h-5" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Delete Confirmation Modal */}
      {deleteId && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-anthracite-light rounded-lg border border-gold/20 p-6 max-w-md w-full">
            <h3 className="text-lg font-semibold text-white mb-4">Projeyi Sil</h3>
            <p className="text-gray-400 mb-6">
              Bu projeyi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.
            </p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={() => setDeleteId(null)}
                className="px-4 py-2 text-gray-400 hover:text-white transition-colors duration-300"
              >
                İptal
              </button>
              <button
                onClick={() => handleDelete(deleteId)}
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition-colors duration-300"
              >
                Sil
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminProjects;